import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import { type OrganizationMember } from '@/types/user';

const fetcher = async (url: string) =>
  await denApi.get<OrganizationMember[], void>(url);

export function useListMembers(
  organizationId: string | null,
  swrOptions?: SWRConfiguration<OrganizationMember[]>
) {
  // Org context comes from x-current-org-id cookie (not URL params)
  const url = organizationId ? `organization/members` : null;
  const { data, error, isLoading, mutate } = useSWR<OrganizationMember[]>(
    url,
    fetcher,
    { revalidateOnFocus: false, refreshInterval: 10000, ...(swrOptions ?? {}) } // Poll every 10 seconds for updates
  );

  return {
    members: data ?? [],
    isLoading,
    error,
    refresh: mutate,
  };
}
